export const LANGUAGE_STORAGE_KEY = 'appLanguage';

export const SUPPORTED_LANGUAGES = ['hu', 'en'];

export const LANGUAGE_TO_LOCALE = {
	hu: 'hu-HU',
	en: 'en-US'
};

export function normalizeLanguage(value) {
	if (!value) return 'hu';
	const shortCode = value.toLowerCase().split('-')[0];
	return SUPPORTED_LANGUAGES.includes(shortCode) ? shortCode : 'hu';
}

export function resolveLocale(language) {
	return LANGUAGE_TO_LOCALE[normalizeLanguage(language)] || LANGUAGE_TO_LOCALE.hu;
}